var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.isAuthorized)?_c('TeacherRoster',{attrs:{"user":_vm.user},on:{"update:user":function($event){_vm.user=$event}}}):(_vm.user.hasRole('student'))?_c('StudentRoster',{attrs:{"user":_vm.user},on:{"update:user":function($event){_vm.user=$event}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }